<template>
    <modal ref="modal" id="new-modal-recharge-history" size="lg">
        <template slot="title">
            <h2 class="mb-0 history-title">{{ t('balance-recharge_history') }}</h2>
        </template>
        <template slot="body">
            <div class="alert alert-next-recharge" v-if="parseFloat(placeCurrentCreditsPerMonth) > 0">
                <strong>{{ t('balance-next_recharge') }}</strong>
                {{ placeCurrentCreditsPerMonth }} {{ t('balance-credits_in') }}
                <human-date :date="nextRecharge" format="[d]/[M]/[Y]" />
            </div>

            <div class="table-responsive mt-3">
                <table class="table table-striped table-list balance-history">
                    <thead>
                        <tr>
                            <th>{{ t('balance-month_year') }}</th>
                            <th>{{ t('balance-description') }}</th>
                            <th>{{ t('balance-amount') }}</th>
                            <th>{{ t('balance-expired') }}</th>
                            <th>{{ t('balance-available') }}</th>
                            <th>{{ t('balance-expiration') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="6" class="text-center text-muted py-4">{{ t('balance-loading_data') }}</td>
                        </tr>
                        <template v-else>
                            <tr v-for="(credit, index) in localCredits" :key="index">
                            <td>
                                <human-date format="[d]/[M]/[Y]" :date="credit.date" />
                            </td>
                            <td>
                                <span v-if="credit.type_of_credit === 'monthly'">{{ t('balance-monthly_plan') }}</span>
                                <span v-else-if="credit.type_of_credit === 'monthly-partial'">{{ t('balance-monthly_adjustment') }}</span>
                                <span v-else-if="credit.type_of_credit === 'single'">{{ t('balance-extra_package') }}</span>
                                <span v-else>{{ t('balance-not_informed') }}</span>
                                <small v-if="credit.description"><br />{{ credit.description }}</small>
                            </td>
                            <td>{{ formatValue(credit.amount) }}</td>
                            <td>{{ formatValue(credit.expired_credits) }}</td>
                            <td>{{ formatValue(credit.available) }}</td>
                            <td>
                                <human-date format="[d]/[M]/[Y]" :date="credit.expiresAt" />
                            </td>
                        </tr>
                        <tr v-if="!localCredits.length">
                            <td colspan="6" class="text-center text-muted">{{ t('balance-no_records_found').replace('{count}', '') }}</td>
                        </tr>
                        </template>
                    </tbody>
                </table>
            </div>

            <div class="mt-3">
                <KvPagination
                    :total="totalRecords"
                    :current-page="currentPage"
                    :items-per-page="itemsPerPage"
                    @page-change="changePage"
                    :show-info="true"
                    :show-items-per-page="false"
                />
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "../../components/modal/modal";
import HumanDate from "../../components/human-date/human-date";
import KvButton from "../../components/form/kv-button.vue";
import KvPagination from "../../components/ui/kv-pagination.vue";
import keviApi from "../../keviApi";

export default {
    components: { Modal, HumanDate, KvButton, KvPagination },
    props: {
        credits: { type: Array, default: () => [] },
        placeCurrentCreditsPerMonth: { type: [Number, String], default: 0 }
    },
    data() {
        return {
            loading: false,
            localCredits: [],
            currentPage: 1,
            itemsPerPage: 10,
            totalPages: 1,
            totalRecords: 0
        };
    },
    computed: {
        nextRecharge() {
            const date = new Date();
            return new Date(
                date.getFullYear(),
                date.getMonth() + 1,
                1
            ).toISOString();
        }
    },
    methods: {
        formatValue(val) {
            return parseFloat(val || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchData();
            }
        },
        async fetchData() {
            this.loading = true;
            try {
                const url = `transactions/credits?page=${this.currentPage}&quantityPerPage=${this.itemsPerPage}`;
                const options = keviApi.getOptions(url, "GET");
                const response = await this.$http(options);
                
                if (response && response.status === 200) {
                    const data = response.body.credits || [];
                    this.localCredits = Array.isArray(data) ? data : Object.values(data);
                    
                    if (response.body.pagination) {
                        this.totalPages = response.body.pagination.totalPages;
                        this.totalRecords = response.body.pagination.total;
                        this.currentPage = response.body.pagination.page;
                    }
                }
            } catch (err) {
                console.error("Erro ao buscar histórico de integrações/recargas:", err);
            } finally {
                this.loading = false;
            }
        },
        open() {
            this.currentPage = 1;
            this.fetchData();
            this.$refs.modal.open();
        },
        close() {
            this.$refs.modal.close();
        }
    }
}
</script>

<style scoped>
.history-title {
    font-size: 20px;
    text-transform: uppercase;
}
.alert-next-recharge {
    background-color: #d1fae5;
    border: 1px solid #a7f3d0;
    color: #065f46;
    border-radius: 8px;
}
.table-list th {
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 500;
}
.table-list td {
    vertical-align: middle;
}
.gap-sm { gap: 8px; }

@media (max-width: 576px) {
    .table-list th,
    .table-list td {
        font-size: 12px;
        padding: 8px 6px;
        white-space: nowrap;
    }
}
</style>
